import CryptoJS from 'crypto-js'

// 2024-11-29 echo - Tutor跳转到kolify的加签名验证
export function encryption(queryString) {
    const params = queryString.split('&').map(param => {
        // 分割每个参数为键值对，并进行小写处理和 URL 编码
        const [key, value] = param.split('=');
        return [key.toLowerCase(), encodeURIComponent(value)];
    });

    // 按键名排序
    params.sort((a, b) => a[0].localeCompare(b[0]));

    // 重新组合成字符串
    const sortedParams = params.map(param => `${param[0]}=${param[1]}`).join('&');
    let str  = sortedParams.toLocaleLowerCase() + 'HqFgxA5j'
    return CryptoJS.MD5(str).toString().toLocaleUpperCase()
    
  }